import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import LogFileCellRenderer from 'components/common/logFileCellRenderer'
import { formatDate } from 'utils/helpers'

type GetColumnsParams = {
  page: number
}

export const getColumns = ({ page }: GetColumnsParams) =>
  [
    {
      headerName: '#',
      field: '_id',
      maxWidth: 80,
      valueFormatter: (params: ValueFormatterParams) => {
        return (params.node?.rowIndex as number) + 1 + page
      },
    },
    {
      headerName: 'Last Mile',
      field: 'lastMileType',
      minWidth: 130,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'Aggregator',
      field: 'aggregator',
      minWidth: 140,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'Store',
      field: 'store',
      minWidth: 120,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'Order No',
      field: 'orderNo',
      minWidth: 150,
    },
    {
      headerName: 'Event Type',
      field: 'eventType',
      minWidth: 180,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'Order Status',
      field: 'orderStatus',
      minWidth: 160,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'Status',
      field: 'status',
      minWidth: 120,
      cellRenderer: (params: ICellRendererParams) => {
        const v: string = params.value
        if (!v) return <span>-</span>
        return (
          <span
            className={`rounded-lg px-2 py-1 text-sm ${
              v === 'SUCCESS'
                ? 'bg-green-400 text-black'
                : 'bg-red-500 text-white'
            }`}
          >
            {v === 'SUCCESS' ? 'Success' : 'Failed'}
          </span>
        )
      },
    },
    {
      headerName: 'Error Message',
      field: 'errorMessage',
      minWidth: 220,
      valueFormatter: (params: ValueFormatterParams) => params.value || '-',
    },
    {
      headerName: 'S3 Log',
      field: 's3LogFile',
      minWidth: 160,
      cellRenderer: (params: ICellRendererParams) => (
        <LogFileCellRenderer params={params} />
      ),
    },
    {
      headerName: 'Created At',
      field: 'createdAt',
      minWidth: 180,
      valueFormatter: (params: ValueFormatterParams) =>
        params.value ? formatDate(params.value, { includeTime: true }) : '-',
    },
  ] as ColDef[]
